import { createGlobalStyle } from "styled-components";
import { designSystemTokenValues as token } from "./tokens";

export const DesignSystemGlobalStyles = createGlobalStyle`
  :root {
    --inzeloop-ds-color-background-page: ${token.color.background.page};
    --inzeloop-ds-color-background-canvas: ${token.color.background.canvas};
    --inzeloop-ds-color-background-surface: ${token.color.background.surface};
    --inzeloop-ds-color-background-subtle: ${token.color.background.subtle};
    --inzeloop-ds-color-background-muted: ${token.color.background.muted};
    --inzeloop-ds-color-background-hover: ${token.color.background.hover};
    --inzeloop-ds-color-background-selected: ${token.color.background.selected};
    --inzeloop-ds-color-background-overlay-light: ${token.color.background.overlayLight};
    --inzeloop-ds-color-background-overlay: ${token.color.background.overlay};
    --inzeloop-ds-color-background-overlay-strong: ${token.color.background.overlayStrong};
    --inzeloop-ds-color-background-disabled: ${token.color.background.disabled};
    --inzeloop-ds-color-background-disabled-strong: ${token.color.background.disabledStrong};
    --inzeloop-ds-color-background-transparent: ${token.color.background.transparent};
    --inzeloop-ds-color-background-raised: ${token.color.background.raised};
    --inzeloop-ds-color-background-neutral: ${token.color.background.neutral};
    --inzeloop-ds-color-background-quiet: ${token.color.background.quiet};
    --inzeloop-ds-color-background-canvas-muted: ${token.color.background.canvasMuted};
    --inzeloop-ds-color-background-track: ${token.color.background.track};
    --inzeloop-ds-color-background-surface-translucent: ${token.color.background.surfaceTranslucent};
    --inzeloop-ds-color-background-surface-muted: ${token.color.background.surfaceMuted};
    --inzeloop-ds-color-background-info-tint: ${token.color.background.infoTint};
    --inzeloop-ds-color-background-danger-tint: ${token.color.background.dangerTint};
    --inzeloop-ds-color-background-success-tint: ${token.color.background.successTint};
    --inzeloop-ds-color-background-neutral-tint: ${token.color.background.neutralTint};
    --inzeloop-ds-color-background-hover-tint: ${token.color.background.hoverTint};
    --inzeloop-ds-color-background-info-soft: ${token.color.background.infoSoft};
    --inzeloop-ds-color-background-aqua-soft: ${token.color.background.aquaSoft};
    --inzeloop-ds-color-background-glass: ${token.color.background.glass};
    --inzeloop-ds-color-background-selection: ${token.color.background.selection};
    --inzeloop-ds-color-background-disabled-control: ${token.color.background.disabledControl};

    --inzeloop-ds-color-text-primary: ${token.color.text.primary};
    --inzeloop-ds-color-text-form-label: ${token.color.text.formLabel};
    --inzeloop-ds-color-text-secondary: ${token.color.text.secondary};
    --inzeloop-ds-color-text-muted: ${token.color.text.muted};
    --inzeloop-ds-color-text-inverse: ${token.color.text.inverse};
    --inzeloop-ds-color-text-accent: ${token.color.text.accent};
    --inzeloop-ds-color-text-danger: ${token.color.text.danger};
    --inzeloop-ds-color-text-disabled: ${token.color.text.disabled};
    --inzeloop-ds-color-text-body: ${token.color.text.body};
    --inzeloop-ds-color-text-subdued: ${token.color.text.subdued};
    --inzeloop-ds-color-text-success: ${token.color.text.success};
    --inzeloop-ds-color-text-strong: ${token.color.text.strong};
    --inzeloop-ds-color-text-subtle: ${token.color.text.subtle};
    --inzeloop-ds-color-text-quiet: ${token.color.text.quiet};
    --inzeloop-ds-color-text-placeholder-strong: ${token.color.text.placeholderStrong};
    --inzeloop-ds-color-text-slate: ${token.color.text.slate};
    --inzeloop-ds-color-text-heading: ${token.color.text.heading};
    --inzeloop-ds-color-text-ai-heading: ${token.color.text.aiHeading};
    --inzeloop-ds-color-text-ink: ${token.color.text.ink};
    --inzeloop-ds-color-text-black-soft: ${token.color.text.blackSoft};
    --inzeloop-ds-color-text-graphite: ${token.color.text.graphite};
    --inzeloop-ds-color-text-dark: ${token.color.text.dark};
    --inzeloop-ds-color-text-disabled-soft: ${token.color.text.disabledSoft};
    --inzeloop-ds-color-text-black-muted: ${token.color.text.blackMuted};
    --inzeloop-ds-color-text-secondary-slate: ${token.color.text.secondarySlate};
    --inzeloop-ds-color-text-navigation: ${token.color.text.navigation};
    --inzeloop-ds-color-text-neutral-dark: ${token.color.text.neutralDark};
    --inzeloop-ds-color-text-neutral: ${token.color.text.neutral};
    --inzeloop-ds-color-text-charcoal: ${token.color.text.charcoal};
    --inzeloop-ds-color-text-dark-strong: ${token.color.text.darkStrong};
    --inzeloop-ds-color-text-quiet-strong: ${token.color.text.quietStrong};
    --inzeloop-ds-color-text-disabled-muted: ${token.color.text.disabledMuted};
    --inzeloop-ds-color-text-teal: ${token.color.text.teal};

    --inzeloop-ds-color-border-subtle: ${token.color.border.subtle};
    --inzeloop-ds-color-border-soft: ${token.color.border.soft};
    --inzeloop-ds-color-border-medium: ${token.color.border.medium};
    --inzeloop-ds-color-border-strong: ${token.color.border.strong};
    --inzeloop-ds-color-border-accent: ${token.color.border.accent};
    --inzeloop-ds-color-border-danger: ${token.color.border.danger};
    --inzeloop-ds-color-border-light: ${token.color.border.light};
    --inzeloop-ds-color-border-transparent: ${token.color.border.transparent};
    --inzeloop-ds-color-border-control: ${token.color.border.control};
    --inzeloop-ds-color-border-disabled: ${token.color.border.disabled};
    --inzeloop-ds-color-border-muted: ${token.color.border.muted};
    --inzeloop-ds-color-border-quiet: ${token.color.border.quiet};
    --inzeloop-ds-color-border-neutral: ${token.color.border.neutral};
    --inzeloop-ds-color-border-input: ${token.color.border.input};
    --inzeloop-ds-color-border-input-strong: ${token.color.border.inputStrong};
    --inzeloop-ds-color-border-compare: ${token.color.border.compare};
    --inzeloop-ds-color-border-default: ${token.color.border.default};
    --inzeloop-ds-color-border-chart: ${token.color.border.chart};
    --inzeloop-ds-color-border-divider: ${token.color.border.divider};
    --inzeloop-ds-color-border-muted-strong: ${token.color.border.mutedStrong};
    --inzeloop-ds-color-border-tag: ${token.color.border.tag};
    --inzeloop-ds-color-border-icon: ${token.color.border.icon};
    --inzeloop-ds-color-border-table-header: ${token.color.border.tableHeader};

    --inzeloop-ds-color-action-primary: ${token.color.action.primary};
    --inzeloop-ds-color-action-primary-hover: ${token.color.action.primaryHover};
    --inzeloop-ds-color-action-primary-hover-strong: ${token.color.action.primaryHoverStrong};
    --inzeloop-ds-color-action-primary-pressed: ${token.color.action.primaryPressed};
    --inzeloop-ds-color-action-ai-gradient: ${token.color.action.aiGradient};
    --inzeloop-ds-color-action-ai-gradient-hover: ${token.color.action.aiGradientHover};
    --inzeloop-ds-color-action-secondary-hover: ${token.color.action.secondaryHover};
    --inzeloop-ds-color-action-danger: ${token.color.action.danger};
    --inzeloop-ds-color-action-danger-hover: ${token.color.action.dangerHover};
    --inzeloop-ds-color-action-success: ${token.color.action.success};
    --inzeloop-ds-color-action-success-hover: ${token.color.action.successHover};
    --inzeloop-ds-color-action-disabled: ${token.color.action.disabled};
    --inzeloop-ds-color-action-selection: ${token.color.action.selection};

    --inzeloop-ds-color-control-background: ${token.color.control.background};
    --inzeloop-ds-color-control-background-disabled: ${token.color.control.backgroundDisabled};
    --inzeloop-ds-color-control-background-subtle: ${token.color.control.backgroundSubtle};
    --inzeloop-ds-color-control-text: ${token.color.control.text};
    --inzeloop-ds-color-control-text-subdued: ${token.color.control.textSubdued};
    --inzeloop-ds-color-control-text-empty: ${token.color.control.textEmpty};
    --inzeloop-ds-color-control-placeholder: ${token.color.control.placeholder};
    --inzeloop-ds-color-control-border: ${token.color.control.border};
    --inzeloop-ds-color-control-border-error: ${token.color.control.borderError};
    --inzeloop-ds-color-control-error-text: ${token.color.control.errorText};
    --inzeloop-ds-color-control-required: ${token.color.control.required};
    --inzeloop-ds-color-control-scrollbar: ${token.color.control.scrollbar};
    --inzeloop-ds-color-control-scrollbar-hover: ${token.color.control.scrollbarHover};

    --inzeloop-ds-color-feedback-error-border: ${token.color.feedback.error.border};
    --inzeloop-ds-color-feedback-error-background: ${token.color.feedback.error.background};
    --inzeloop-ds-color-feedback-error-solid: ${token.color.feedback.error.solid};
    --inzeloop-ds-color-feedback-success-border: ${token.color.feedback.success.border};
    --inzeloop-ds-color-feedback-success-background: ${token.color.feedback.success.background};
    --inzeloop-ds-color-feedback-success-solid: ${token.color.feedback.success.solid};
    --inzeloop-ds-color-feedback-info-border: ${token.color.feedback.info.border};
    --inzeloop-ds-color-feedback-info-background: ${token.color.feedback.info.background};
    --inzeloop-ds-color-feedback-info-solid: ${token.color.feedback.info.solid};
    --inzeloop-ds-color-feedback-warning-border: ${token.color.feedback.warning.border};
    --inzeloop-ds-color-feedback-warning-background: ${token.color.feedback.warning.background};
    --inzeloop-ds-color-feedback-warning-text: ${token.color.feedback.warning.text};

    --inzeloop-ds-color-icon-primary: ${token.color.icon.primary};
    --inzeloop-ds-color-icon-inverse: ${token.color.icon.inverse};
    --inzeloop-ds-color-icon-muted: ${token.color.icon.muted};
    --inzeloop-ds-color-icon-danger: ${token.color.icon.danger};
    --inzeloop-ds-color-icon-success: ${token.color.icon.success};
    --inzeloop-ds-color-icon-positive: ${token.color.icon.positive};
    --inzeloop-ds-color-icon-positive-strong: ${token.color.icon.positiveStrong};
    --inzeloop-ds-color-icon-info: ${token.color.icon.info};
    --inzeloop-ds-color-icon-neutral: ${token.color.icon.neutral};
    --inzeloop-ds-color-icon-ink: ${token.color.icon.ink};
    --inzeloop-ds-color-icon-ai-mid: ${token.color.icon.aiMid};

    --inzeloop-ds-color-data-viz-one-background: ${token.color.dataVisualization.one.background};
    --inzeloop-ds-color-data-viz-one-border: ${token.color.dataVisualization.one.border};
    --inzeloop-ds-color-data-viz-one-text: ${token.color.dataVisualization.one.text};
    --inzeloop-ds-color-data-viz-two-background: ${token.color.dataVisualization.two.background};
    --inzeloop-ds-color-data-viz-two-border: ${token.color.dataVisualization.two.border};
    --inzeloop-ds-color-data-viz-two-text: ${token.color.dataVisualization.two.text};
    --inzeloop-ds-color-data-viz-four-background: ${token.color.dataVisualization.four.background};
    --inzeloop-ds-color-data-viz-four-border: ${token.color.dataVisualization.four.border};
    --inzeloop-ds-color-data-viz-four-text: ${token.color.dataVisualization.four.text};
    --inzeloop-ds-color-data-viz-five-background: ${token.color.dataVisualization.five.background};
    --inzeloop-ds-color-data-viz-five-border: ${token.color.dataVisualization.five.border};
    --inzeloop-ds-color-data-viz-five-accent: ${token.color.dataVisualization.five.accent};
    --inzeloop-ds-color-data-viz-five-text: ${token.color.dataVisualization.five.text};
    --inzeloop-ds-color-data-viz-five-strong-text: ${token.color.dataVisualization.five.strongText};
    --inzeloop-ds-color-data-viz-nine-background: ${token.color.dataVisualization.nine.background};
    --inzeloop-ds-color-data-viz-nine-border: ${token.color.dataVisualization.nine.border};
    --inzeloop-ds-color-data-viz-nine-text: ${token.color.dataVisualization.nine.text};
    --inzeloop-ds-color-data-viz-score-excellent: ${token.color.dataVisualization.score.excellent};
    --inzeloop-ds-color-data-viz-score-good: ${token.color.dataVisualization.score.good};
    --inzeloop-ds-color-data-viz-score-caution: ${token.color.dataVisualization.score.caution};
    --inzeloop-ds-color-data-viz-score-caution-background: ${token.color.dataVisualization.score.cautionBackground};
    --inzeloop-ds-color-data-viz-score-poor: ${token.color.dataVisualization.score.poor};
    --inzeloop-ds-color-data-viz-comparison-axis: ${token.color.dataVisualization.comparison.axis};
    --inzeloop-ds-color-data-viz-comparison-label: ${token.color.dataVisualization.comparison.label};

    --inzeloop-ds-color-status-active-border: ${token.color.status.active.border};
    --inzeloop-ds-color-status-active-background: ${token.color.status.active.background};
    --inzeloop-ds-color-status-active-text: ${token.color.status.active.text};
    --inzeloop-ds-color-status-pending-border: ${token.color.status.pending.border};
    --inzeloop-ds-color-status-pending-background: ${token.color.status.pending.background};
    --inzeloop-ds-color-status-pending-text: ${token.color.status.pending.text};
    --inzeloop-ds-color-status-deleted-background: ${token.color.status.deleted.background};
    --inzeloop-ds-color-status-deleted-text: ${token.color.status.deleted.text};
    --inzeloop-ds-color-status-disabled-border: ${token.color.status.disabled.border};
    --inzeloop-ds-color-status-disabled-background: ${token.color.status.disabled.background};
    --inzeloop-ds-color-status-disabled-text: ${token.color.status.disabled.text};
    --inzeloop-ds-color-status-invited-border: ${token.color.status.invited.border};
    --inzeloop-ds-color-status-invited-text: ${token.color.status.invited.text};
    --inzeloop-ds-color-status-company-border: ${token.color.status.company.border};
    --inzeloop-ds-color-status-company-background: ${token.color.status.company.background};
    --inzeloop-ds-color-status-positive-text: ${token.color.status.positive.text};
    --inzeloop-ds-color-status-positive-strong: ${token.color.status.positive.strong};
    --inzeloop-ds-color-status-positive-muted: ${token.color.status.positive.muted};
    --inzeloop-ds-color-status-negative-text: ${token.color.status.negative.text};
    --inzeloop-ds-color-status-negative-strong: ${token.color.status.negative.strong};
    --inzeloop-ds-color-status-negative-accent: ${token.color.status.negative.accent};
    --inzeloop-ds-color-status-success-action-background: ${token.color.status.successAction.background};
    --inzeloop-ds-color-status-success-action-hover: ${token.color.status.successAction.hover};
    --inzeloop-ds-color-status-success-action-disabled: ${token.color.status.successAction.disabled};
    --inzeloop-ds-color-status-destructive-action-background: ${token.color.status.destructiveAction.background};
    --inzeloop-ds-color-status-destructive-action-hover: ${token.color.status.destructiveAction.hover};
    --inzeloop-ds-color-status-destructive-action-success-background: ${token.color.status.destructiveAction.successBackground};
    --inzeloop-ds-color-status-destructive-action-success-hover: ${token.color.status.destructiveAction.successHover};

    --inzeloop-ds-color-workflow-job-brief: ${token.color.workflow.jobBrief};
    --inzeloop-ds-color-workflow-scorecard: ${token.color.workflow.scorecard};
    --inzeloop-ds-color-workflow-hiring-process: ${token.color.workflow.hiringProcess};
    --inzeloop-ds-color-workflow-job-description: ${token.color.workflow.jobDescription};
    --inzeloop-ds-color-workflow-sourcing: ${token.color.workflow.sourcing};
    --inzeloop-ds-color-workflow-assessment: ${token.color.workflow.assessment};
    --inzeloop-ds-color-workflow-assessment-subtle: ${token.color.workflow.assessmentSubtle};
    --inzeloop-ds-color-workflow-offer: ${token.color.workflow.offer};
    --inzeloop-ds-color-workflow-completed: ${token.color.workflow.completed};
    --inzeloop-ds-color-workflow-setup: ${token.color.workflow.setup};
    --inzeloop-ds-color-workflow-archived: ${token.color.workflow.archived};
    --inzeloop-ds-color-workflow-evaluation: ${token.color.workflow.evaluation};
    --inzeloop-ds-color-workflow-additional: ${token.color.workflow.additional};
    --inzeloop-ds-color-workflow-muted: ${token.color.workflow.muted};
    --inzeloop-ds-color-workflow-rose: ${token.color.workflow.rose};
    --inzeloop-ds-color-workflow-cyan: ${token.color.workflow.cyan};

    --inzeloop-ds-font-family-sans: ${token.typography.family.sans};
    --inzeloop-ds-font-family-mono: ${token.typography.family.mono};
    --inzeloop-ds-font-size-10px: ${token.typography.size.px10};
    --inzeloop-ds-font-size-11px: ${token.typography.size.px11};
    --inzeloop-ds-font-size-11-8px: ${token.typography.size.px11_8};
    --inzeloop-ds-font-size-11-808px: ${token.typography.size.px11_808};
    --inzeloop-ds-font-size-xs: ${token.typography.size.xs};
    --inzeloop-ds-font-size-12px: ${token.typography.size.px12};
    --inzeloop-ds-font-size-13px: ${token.typography.size.px13};
    --inzeloop-ds-font-size-13-6px: ${token.typography.size.px13_6};
    --inzeloop-ds-font-size-14px: ${token.typography.size.px14};
    --inzeloop-ds-font-size-14-16px: ${token.typography.size.px14_16};
    --inzeloop-ds-font-size-sm: ${token.typography.size.sm};
    --inzeloop-ds-font-size-14-2px: ${token.typography.size.px14_2};
    --inzeloop-ds-font-size-14-4px: ${token.typography.size.px14_4};
    --inzeloop-ds-font-size-14-7px: ${token.typography.size.px14_7};
    --inzeloop-ds-font-size-15px: ${token.typography.size.px15};
    --inzeloop-ds-font-size-15-5px: ${token.typography.size.px15_5};
    --inzeloop-ds-font-size-16px: ${token.typography.size.px16};
    --inzeloop-ds-font-size-md: ${token.typography.size.md};
    --inzeloop-ds-font-size-18px: ${token.typography.size.px18};
    --inzeloop-ds-font-size-20px: ${token.typography.size.px20};
    --inzeloop-ds-font-size-lg: ${token.typography.size.lg};
    --inzeloop-ds-font-size-21px: ${token.typography.size.px21};
    --inzeloop-ds-font-size-22px: ${token.typography.size.px22};
    --inzeloop-ds-font-size-24px: ${token.typography.size.px24};
    --inzeloop-ds-font-size-xl: ${token.typography.size.xl};
    --inzeloop-ds-font-size-25px: ${token.typography.size.px25};
    --inzeloop-ds-font-size-30px: ${token.typography.size.px30};
    --inzeloop-ds-font-size-32-25px: ${token.typography.size.px32_25};
    --inzeloop-ds-font-size-34px: ${token.typography.size.px34};
    --inzeloop-ds-font-size-35px: ${token.typography.size.px35};
    --inzeloop-ds-font-size-35-25px: ${token.typography.size.px35_25};
    --inzeloop-ds-font-size-36px: ${token.typography.size.px36};
    --inzeloop-ds-font-size-42px: ${token.typography.size.px42};
    --inzeloop-ds-font-size-48px: ${token.typography.size.px48};
    --inzeloop-ds-font-size-50px: ${token.typography.size.px50};
    --inzeloop-ds-font-size-52px: ${token.typography.size.px52};
    --inzeloop-ds-font-size-55px: ${token.typography.size.px55};
    --inzeloop-ds-font-size-58px: ${token.typography.size.px58};
    --inzeloop-ds-font-size-64px: ${token.typography.size.px64};
    --inzeloop-ds-font-size-112px: ${token.typography.size.px112};
    --inzeloop-ds-font-size-relative-36: ${token.typography.size.relative36};
    --inzeloop-ds-font-size-relative-half: ${token.typography.size.relativeHalf};
    --inzeloop-ds-font-size-keyword-large: ${token.typography.size.keywordLarge};
    --inzeloop-ds-font-size-keyword-larger: ${token.typography.size.keywordLarger};
    --inzeloop-ds-font-size-1-5vw: ${token.typography.size.vw1_5};
    --inzeloop-ds-font-size-1-8vw: ${token.typography.size.vw1_8};
    --inzeloop-ds-font-size-2-8vw: ${token.typography.size.vw2_8};
    --inzeloop-ds-font-size-4vw: ${token.typography.size.vw4};
    --inzeloop-ds-font-size-5vw: ${token.typography.size.vw5};
    --inzeloop-ds-font-size-8vw: ${token.typography.size.vw8};
    --inzeloop-ds-line-height-condensed: ${token.typography.lineHeight.condensed};
    --inzeloop-ds-line-height-tight: ${token.typography.lineHeight.tight};
    --inzeloop-ds-line-height-snug: ${token.typography.lineHeight.snug};
    --inzeloop-ds-line-height-control: ${token.typography.lineHeight.control};
    --inzeloop-ds-line-height-relaxed: ${token.typography.lineHeight.relaxed};
    --inzeloop-ds-line-height-body: ${token.typography.lineHeight.body};
    --inzeloop-ds-line-height-xs: ${token.typography.lineHeight.xs};
    --inzeloop-ds-line-height-17-712px: ${token.typography.lineHeight.px17_712};
    --inzeloop-ds-line-height-10px: ${token.typography.lineHeight.px10};
    --inzeloop-ds-line-height-14px: ${token.typography.lineHeight.px14};
    --inzeloop-ds-line-height-2-8vw: ${token.typography.lineHeight.vw2_8};
    --inzeloop-ds-line-height-18px: ${token.typography.lineHeight.px18};
    --inzeloop-ds-line-height-20px: ${token.typography.lineHeight.px20};
    --inzeloop-ds-line-height-21-24px: ${token.typography.lineHeight.px21_24};
    --inzeloop-ds-line-height-21-255px: ${token.typography.lineHeight.px21_255};
    --inzeloop-ds-line-height-22px: ${token.typography.lineHeight.px22};
    --inzeloop-ds-line-height-sm: ${token.typography.lineHeight.sm};
    --inzeloop-ds-line-height-md: ${token.typography.lineHeight.md};
    --inzeloop-ds-line-height-25-5px: ${token.typography.lineHeight.px25_5};
    --inzeloop-ds-line-height-26px: ${token.typography.lineHeight.px26};
    --inzeloop-ds-line-height-26-52px: ${token.typography.lineHeight.px26_52};
    --inzeloop-ds-line-height-27px: ${token.typography.lineHeight.px27};
    --inzeloop-ds-line-height-lg: ${token.typography.lineHeight.lg};
    --inzeloop-ds-line-height-xl: ${token.typography.lineHeight.xl};
    --inzeloop-ds-line-height-40px: ${token.typography.lineHeight.px40};
    --inzeloop-ds-line-height-48px: ${token.typography.lineHeight.px48};
    --inzeloop-ds-line-height-52px: ${token.typography.lineHeight.px52};
    --inzeloop-ds-font-weight-light: ${token.typography.weight.light};
    --inzeloop-ds-font-weight-regular: ${token.typography.weight.regular};
    --inzeloop-ds-font-weight-medium: ${token.typography.weight.medium};
    --inzeloop-ds-font-weight-semibold: ${token.typography.weight.semibold};
    --inzeloop-ds-font-weight-bold: ${token.typography.weight.bold};

    --inzeloop-ds-spacing-none: ${token.spacing.none};
    --inzeloop-ds-spacing-1px: ${token.spacing.px1};
    --inzeloop-ds-spacing-xxs: ${token.spacing.xxs};
    --inzeloop-ds-spacing-3px: ${token.spacing.px3};
    --inzeloop-ds-spacing-xs: ${token.spacing.xs};
    --inzeloop-ds-spacing-5px: ${token.spacing.px5};
    --inzeloop-ds-spacing-5-5px: ${token.spacing.px5_5};
    --inzeloop-ds-spacing-6px: ${token.spacing.px6};
    --inzeloop-ds-spacing-7px: ${token.spacing.px7};
    --inzeloop-ds-spacing-sm: ${token.spacing.sm};
    --inzeloop-ds-spacing-9px: ${token.spacing.px9};
    --inzeloop-ds-spacing-9-6px: ${token.spacing.px9_6};
    --inzeloop-ds-spacing-10px: ${token.spacing.px10};
    --inzeloop-ds-spacing-11px: ${token.spacing.px11};
    --inzeloop-ds-spacing-md: ${token.spacing.md};
    --inzeloop-ds-spacing-13px: ${token.spacing.px13};
    --inzeloop-ds-spacing-14px: ${token.spacing.px14};
    --inzeloop-ds-spacing-15px: ${token.spacing.px15};
    --inzeloop-ds-spacing-lg: ${token.spacing.lg};
    --inzeloop-ds-spacing-17px: ${token.spacing.px17};
    --inzeloop-ds-spacing-18px: ${token.spacing.px18};
    --inzeloop-ds-spacing-19-2px: ${token.spacing.px19_2};
    --inzeloop-ds-spacing-20px: ${token.spacing.px20};
    --inzeloop-ds-spacing-22px: ${token.spacing.px22};
    --inzeloop-ds-spacing-xl: ${token.spacing.xl};
    --inzeloop-ds-spacing-25px: ${token.spacing.px25};
    --inzeloop-ds-spacing-28px: ${token.spacing.px28};
    --inzeloop-ds-spacing-29px: ${token.spacing.px29};
    --inzeloop-ds-spacing-30px: ${token.spacing.px30};
    --inzeloop-ds-spacing-2xl: ${token.spacing["2xl"]};
    --inzeloop-ds-spacing-35px: ${token.spacing.px35};
    --inzeloop-ds-spacing-36px: ${token.spacing.px36};
    --inzeloop-ds-spacing-3xl: ${token.spacing["3xl"]};
    --inzeloop-ds-spacing-42px: ${token.spacing.px42};
    --inzeloop-ds-spacing-45px: ${token.spacing.px45};
    --inzeloop-ds-spacing-46px: ${token.spacing.px46};
    --inzeloop-ds-spacing-48px: ${token.spacing.px48};
    --inzeloop-ds-spacing-50px: ${token.spacing.px50};
    --inzeloop-ds-spacing-56px: ${token.spacing.px56};
    --inzeloop-ds-spacing-60px: ${token.spacing.px60};
    --inzeloop-ds-spacing-63px: ${token.spacing.px63};
    --inzeloop-ds-spacing-64px: ${token.spacing.px64};
    --inzeloop-ds-spacing-72px: ${token.spacing.px72};
    --inzeloop-ds-spacing-80px: ${token.spacing.px80};
    --inzeloop-ds-spacing-100px: ${token.spacing.px100};
    --inzeloop-ds-spacing-120px: ${token.spacing.px120};
    --inzeloop-ds-spacing-132px: ${token.spacing.px132};
    --inzeloop-ds-spacing-190px: ${token.spacing.px190};
    --inzeloop-ds-spacing-percent-1: ${token.spacing.percent1};
    --inzeloop-ds-spacing-percent-2: ${token.spacing.percent2};
    --inzeloop-ds-spacing-2mm: ${token.spacing.mm2};
    --inzeloop-ds-spacing-6mm: ${token.spacing.mm6};

    --inzeloop-ds-radius-none: ${token.radius.none};
    --inzeloop-ds-radius-2xs: ${token.radius["2xs"]};
    --inzeloop-ds-radius-xxs: ${token.radius.xxs};
    --inzeloop-ds-radius-xs: ${token.radius.xs};
    --inzeloop-ds-radius-compact: ${token.radius.compact};
    --inzeloop-ds-radius-control: ${token.radius.control};
    --inzeloop-ds-radius-sm: ${token.radius.sm};
    --inzeloop-ds-radius-relaxed: ${token.radius.relaxed};
    --inzeloop-ds-radius-md: ${token.radius.md};
    --inzeloop-ds-radius-rounded: ${token.radius.rounded};
    --inzeloop-ds-radius-lg: ${token.radius.lg};
    --inzeloop-ds-radius-xl: ${token.radius.xl};
    --inzeloop-ds-radius-2xl: ${token.radius["2xl"]};
    --inzeloop-ds-radius-3xl: ${token.radius["3xl"]};
    --inzeloop-ds-radius-4xl: ${token.radius["4xl"]};
    --inzeloop-ds-radius-circle: ${token.radius.circle};
    --inzeloop-ds-radius-full: ${token.radius.full};

    --inzeloop-ds-border-width-hairline: ${token.borderWidth.hairline};
    --inzeloop-ds-border-width-thin: ${token.borderWidth.thin};
    --inzeloop-ds-border-width-emphasized: ${token.borderWidth.emphasized};
    --inzeloop-ds-border-width-medium: ${token.borderWidth.medium};
    --inzeloop-ds-border-width-thick: ${token.borderWidth.thick};

    --inzeloop-ds-shadow-sm: ${token.shadow.sm};
    --inzeloop-ds-shadow-compact-dialog: ${token.shadow.compactDialog};
    --inzeloop-ds-shadow-popup: ${token.shadow.popup};
    --inzeloop-ds-shadow-md: ${token.shadow.md};
    --inzeloop-ds-shadow-lg: ${token.shadow.lg};
    --inzeloop-ds-shadow-dropdown: ${token.shadow.dropdown};
    --inzeloop-ds-shadow-panel: ${token.shadow.panel};
    --inzeloop-ds-shadow-tooltip: ${token.shadow.tooltip};
    --inzeloop-ds-shadow-frozen-left: ${token.shadow.frozenLeft};
    --inzeloop-ds-shadow-frozen-right: ${token.shadow.frozenRight};
    --inzeloop-ds-shadow-table-menu: ${token.shadow.tableMenu};
    --inzeloop-ds-shadow-navigation: ${token.shadow.navigation};
    --inzeloop-ds-shadow-header: ${token.shadow.header};
    --inzeloop-ds-shadow-header-menu: ${token.shadow.headerMenu};
    --inzeloop-ds-shadow-header-edge: ${token.shadow.headerEdge};
    --inzeloop-ds-shadow-drag: ${token.shadow.drag};
    --inzeloop-ds-shadow-raised: ${token.shadow.raised};
    --inzeloop-ds-shadow-card: ${token.shadow.card};
    --inzeloop-ds-shadow-control: ${token.shadow.control};
    --inzeloop-ds-shadow-faint: ${token.shadow.faint};
    --inzeloop-ds-shadow-dark-soft: ${token.shadow.darkSoft};
    --inzeloop-ds-shadow-bottom: ${token.shadow.bottom};
    --inzeloop-ds-shadow-focus:
      0 0 0 1px ${token.color.focus.inner},
      0 0 0 3px ${token.color.focus.center},
      0 0 0 5px ${token.color.focus.outer};

    --inzeloop-ds-motion-fast: ${token.motion.fast};
    --inzeloop-ds-motion-normal: ${token.motion.normal};
    --inzeloop-ds-motion-slow: ${token.motion.slow};
    --inzeloop-ds-motion-processing: ${token.motion.processing};
    --inzeloop-ds-motion-attention-interval: ${token.motion.attentionInterval};
    --inzeloop-ds-motion-easing: ${token.motion.easing};

    --inzeloop-ds-z-index-dropdown: ${token.zIndex.dropdown};
    --inzeloop-ds-z-index-overlay: ${token.zIndex.overlay};
    --inzeloop-ds-z-index-dialog: ${token.zIndex.dialog};
    --inzeloop-ds-z-index-toast: ${token.zIndex.toast};

    --inzeloop-ds-layout-content-max-width: ${token.layout.contentMaxWidth};
    --inzeloop-ds-layout-page-content-max-width: ${token.layout.pageContentMaxWidth};
    --inzeloop-ds-layout-page-inline-gutter: ${token.layout.pageInlineGutter};
    --inzeloop-ds-layout-page-inline-gutter-compact: ${token.layout.pageInlineGutterCompact};
    --inzeloop-ds-layout-drawer-width: ${token.layout.drawerWidth};
    --inzeloop-ds-layout-ai-context-modal-width: ${token.layout.aiContextModalWidth};
    --inzeloop-ds-layout-task-modal-width: ${token.layout.taskModalWidth};
    --inzeloop-ds-layout-task-modal-body-max-height: ${token.layout.taskModalBodyMaxHeight};
    --inzeloop-ds-layout-ai-context-prompt-height: ${token.layout.aiContextPromptHeight};
    --inzeloop-ds-layout-ai-context-generate-width: ${token.layout.aiContextGenerateWidth};
    --inzeloop-ds-layout-fixed-action-clearance: ${token.layout.fixedActionClearance};
    --inzeloop-ds-layout-top-navigation-height: ${token.layout.topNavigationHeight};

  }

  form,
  form label,
  form input,
  form textarea,
  form select {
    font-family: ${token.typography.family.sans};
  }

  :where(
    button:disabled:not([aria-busy="true"]),
    input:is([type="button"], [type="submit"], [type="reset"]):disabled:not([aria-busy="true"]),
    [aria-disabled="true"]:not([aria-busy="true"])
  ),
  :where(
    button:disabled:not([aria-busy="true"]),
    input:is([type="button"], [type="submit"], [type="reset"]):disabled:not([aria-busy="true"]),
    [aria-disabled="true"]:not([aria-busy="true"])
  ) * {
    cursor: not-allowed !important;
  }

  :where(
    [data-tooltip-trigger]:has(> button:disabled:not([aria-busy="true"])),
    [data-tooltip-trigger]:has(> [aria-disabled="true"]:not([aria-busy="true"]))
  ) {
    cursor: not-allowed !important;
  }
`;
